import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Aircraft from "./pages/Aircraft";
import VehicleDetail from "./pages/VehicleDetail";
import VehicleCategory from "./pages/VehicleCategory";
import Team from "./pages/Team";
import BuildLogs, { BuildLogDetail } from "./pages/BuildLogs";
import Sponsors from "./pages/Sponsors";
import Contact from "./pages/Contact";
import Achievements from "./pages/Achievements";
import { Toaster } from "./components/ui/sonner";

// Admin imports
import ProtectedRoute from "./components/ProtectedRoute";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminContent from "./pages/admin/AdminContent";
import AdminAircraft from "./pages/admin/AdminAircraft";
import { AdminBuildLogs, AdminBuildLogForm } from "./pages/admin/AdminBuildLogs";
import { AdminTeam, AdminTeamForm } from "./pages/admin/AdminTeam";
import { AdminSponsors, AdminSponsorForm } from "./pages/admin/AdminSponsors";
import AdminMessages from "./pages/admin/AdminMessages";
import AdminDocuments from "./pages/admin/AdminDocuments";
import AdminUserManagement from "./pages/admin/AdminUserManagement";
import AdminProfile from "./pages/admin/AdminProfile";
import AdminGallery from "./pages/admin/AdminGallery";
import AdminAchievements from "./pages/admin/AdminAchievements";
import AdminYouTube from "./pages/admin/AdminYouTube";
import { AdminVehicleGallery, AdminVehicleGalleryForm } from "./pages/admin/AdminVehicleGallery";
import AdminVehicleCategories from "./pages/admin/AdminVehicleCategories";
import AdminCompetitionDocs from "./pages/admin/AdminCompetitionDocs";
import AdminBackup from "./pages/admin/AdminBackup";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
          {/* Public Routes */}
          <Route path="/" element={<><Header /><Home /><Footer /></>} />
          <Route path="/aircraft" element={<><Header /><Aircraft /><Footer /></>} />
          <Route path="/vehicles/:categoryId" element={<><Header /><VehicleCategory /><Footer /></>} />
          <Route path="/vehicle/:id" element={<><Header /><VehicleDetail /><Footer /></>} />
          <Route path="/team" element={<><Header /><Team /><Footer /></>} />
          <Route path="/build-logs" element={<><Header /><BuildLogs /><Footer /></>} />
          <Route path="/build-logs/:id" element={<><Header /><BuildLogDetail /><Footer /></>} />
          <Route path="/sponsors" element={<><Header /><Sponsors /><Footer /></>} />
          <Route path="/contact" element={<><Header /><Contact /><Footer /></>} />
          <Route path="/achievements" element={<><Header /><Achievements /><Footer /></>} />
          
          {/* Admin Login */}
          <Route path="/admin/login" element={<AdminLogin />} />
          
          {/* Protected Admin Routes */}
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<AdminDashboard />} />
            <Route path="content" element={<AdminContent />} />
            <Route path="aircraft" element={<AdminAircraft />} />
            <Route path="build-logs" element={<AdminBuildLogs />} />
            <Route path="build-logs/new" element={<AdminBuildLogForm />} />
            <Route path="build-logs/:id" element={<AdminBuildLogForm />} />
            <Route path="team" element={<AdminTeam />} />
            <Route path="team/new" element={<AdminTeamForm />} />
            <Route path="team/:id" element={<AdminTeamForm />} />
            <Route path="sponsors" element={<AdminSponsors />} />
            <Route path="sponsors/new" element={<AdminSponsorForm />} />
            <Route path="sponsors/:id" element={<AdminSponsorForm />} />
            <Route path="messages" element={<AdminMessages />} />
            <Route path="documents" element={<AdminDocuments />} />
            <Route path="competition-docs" element={<AdminCompetitionDocs />} />
            <Route path="gallery" element={<AdminGallery />} />
            <Route path="achievements" element={<AdminAchievements />} />
            <Route path="youtube" element={<AdminYouTube />} />
            <Route path="vehicle-gallery" element={<AdminVehicleGallery />} />
            <Route path="vehicle-gallery/new" element={<AdminVehicleGalleryForm />} />
            <Route path="vehicle-gallery/:id" element={<AdminVehicleGalleryForm />} />
            <Route path="vehicle-categories" element={<AdminVehicleCategories />} />
            <Route path="users" element={<AdminUserManagement />} />
            <Route path="backup" element={<AdminBackup />} />
            <Route path="profile" element={<AdminProfile />} />
          </Route>
        </Routes>
          <Toaster />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
